module.exports = __webpack_public_path__ + "static/media/loan.fc17dc90.svg";